import React, { useEffect, useRef, useState } from "react";

export default function CountUp({ value, duration = 1400 }) {
  const text = String(value);
  const match = text.match(/^([^\d]*)(\d+(?:\.\d+)?)(.*)$/);
  const ref = useRef(null);
  const [current, setCurrent] = useState(match ? 0 : null);

  useEffect(() => {
    if (!match) return undefined;
    const target = parseFloat(match[2]);
    const decimals = (match[2].split(".")[1] || "").length;
    const node = ref.current;
    let frame;

    const run = () => {
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        setCurrent(Number((target * eased).toFixed(decimals)));
        if (p < 1) frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
    };

    if (!("IntersectionObserver" in window)) { setCurrent(target); return undefined; }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { run(); observer.disconnect(); }
    }, { threshold: 0.4 });
    observer.observe(node);
    return () => { observer.disconnect(); cancelAnimationFrame(frame); };
  }, [text]);

  if (!match) return <span ref={ref}>{text}</span>;
  const decimals = (match[2].split(".")[1] || "").length;
  return <span ref={ref}>{match[1]}{current === null ? match[2] : current.toFixed(decimals)}{match[3]}</span>;
}
